import React from "react";
import DataTable from "../../components/data-table";
import ValidationReg from "../../common/ValidationReg";
import Auth from "../../utils/auth";
import * as contactService from "../../services/kyc/kyc-service";
import * as masterService from "../../services/master/master-service";
import * as xmlService from "../../services/xml/xml-service";
import * as kyc from "../../services/kyc/kyc-service";
import { Link } from "react-router-dom";
import { CSVLink } from "react-csv";
import { Authorize } from "../../components/authorize";
import { validateEntitlement } from "../../common/validate-entitlement";
import {
  FUNCTIONALITY,
  ENTITLEMENTS,
  defaultListItem,
  genders,
} from "../../common/const";
import * as Loader from "../../common/common";
import utility from "../../components/modal";
import TextBox from "../../components/form-controls/textbox";
import { messages } from "../../common/messages";
import DropDown from "../../components/form-controls/dropdown";
import { commonDownloadPdf } from "../../common/download-pdf";
import * as commonDownloadPdfService from "../../services/pdf/download_pdf_service";
import XmlDownload from "../../components/xml-download/xml-download";
// import { config } from "winston";
import config from "../../common/config";
import { withOutletPropsAndNavigation } from "../../common/hocs";

const { v4: uuidv4 } = require("uuid");

class ContactList extends Authorize {
  constructor(props) {
    super(props);
    this.buttonClick = this.buttonClick.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.deleteMsg = "";
    this.deleteErr = "";
    this.onClear = this.onClear.bind(this);
    this.generateContactXml = this.generateContactXml.bind(this);
    this.getContactsForCSV = this.getContactsForCSV.bind(this);
    this.handlePrevNext = this.handlePrevNext.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
    this.downloadPdfList = this.downloadPdfList.bind(this);
  }

  state = {
    clientId: this.props.clientId,
    userType: this.props.clientType,
    user: {
      id: "",
      contactId: "",
      clientId: "",
      contactType: "",
      contactCode: "",
      contactPerson: "",
      title: "",
      salutation: "",
      lookupCode: "",
      designation: "",
      gender: "",
      emailId: "",
      telephoneNo: "",
      telephoneExt: "",
      mobileNo: "",
      faxNumber: "",
      comment: "",
    },
    contactTypeData: "",
    validationErrors: {},
    msg: "",
    error: "",
    deleteMsg: "",
    deleteErr: "",
    showModel: false,

    editflag: false,
    headers: [
      {
        title: "Name",
        accessor: "contactPerson",
        index: 1,
        dataType: "string",
      },
      { title: "Title", accessor: "title", index: 2, dataType: "string" },
      {
        title: "Designation",
        accessor: "designation",
        index: 4,
        dataType: "string",
      },
      { title: "Gender", accessor: "gender", index: 5, dataType: "string" },
      { title: "Email", accessor: "emailId", index: 6, dataType: "string" },
      {
        title: "",
        accessor: "id",
        index: 12,
        cell: (row) => {
          return (
            <div key={row.contactId} className="btn-group  float-right">
              {validateEntitlement(
                FUNCTIONALITY.contacts,
                ENTITLEMENTS.edit
              ) ? (
                <button
                  title="Edit"
                  type="button"
                  onClick={this.onEdit.bind(this, row.contactId)}
                  className="btn btn-sm btn-primary fas fa-edit rounded-0"
                ></button>
              ) : null}
              {validateEntitlement(
                FUNCTIONALITY.contacts,
                ENTITLEMENTS.delete
              ) ? (
                <button
                  title="Delete"
                  onClick={this.onDelete.bind(this, row.contactId)}
                  type="button"
                  className="btn btn-sm btn-danger fas fa-trash-alt rounded-0"
                ></button>
              ) : null}
              <button
                title="Download as PDF"
                onClick={this.downloadPdf.bind(
                  this,
                  this.state.clientId,
                  row.contactId
                )}
                type="button"
                className="btn btn-sm btn-warning rounded-0"
              >
                <span className="fa fa-download"></span>
              </button>
            </div>
          );
        },
      },
    ],
    data: [],
    csvData: [],
    csvHeaders: [],
    regenerateMsg: "",
    isDisabled: false,
  };

  kycStatus = "";

  async getAllContactList() {
    let clientId = this.state.clientId;
    Loader.showLoader();
    let { response, err } = await contactService.getContactList(clientId);
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      this.setState({
        data: response.data && response.data.length > 0 ? response.data : [],
      });
    }
  }

  async downloadPdf(clientId, contactId) {
    let data = {
      clientId: clientId,
      contactId: contactId,
    };
    let { response, err } = await commonDownloadPdfService.downloadContact(
      data
    );
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(response.data, "Contact_" + clientId + "_" + contactId);
    }
  }

  async downloadPdfList(clientId) {
    let data = {
      clientId: clientId,
    };
    let { response, err } = await commonDownloadPdfService.downloadContactList(
      data
    );
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(response.data, "ContactList_" + clientId);
    }
  }

  onEdit(id, e) {
    let editData = Object.assign([], this.state.data);

    let newArray = editData.filter(function (el) {
      return el.contactId === id;
    });

    this.setState({
      user: newArray[0],
      editflag: true,
      error: "",
      msg: "",
      deleteMsg: "",
      showModel: !this.state.showModel,
    });
  }

  validateContact_details(id) {
    let tax_responsible_person_list = [];
    let acPayable_responsible_person_list = [];
    let acReceivable_responsible_person_list = [];
    let msg = "";
    let contact_row = this.state.data.find((v) => v.contactId === id);
    if (contact_row.contactType === "TAX responsible person") {
      tax_responsible_person_list = this.state.data.filter((con) => {
        if (con.contactType === "TAX responsible person") return con;
      });
      if (tax_responsible_person_list.length < 2) {
        msg = "TAX responsible person contact";
      }
    } else if (this.props.clientType !== "Customer") {
      if (contact_row.contactType === "A/c receivable responsible person") {
        acReceivable_responsible_person_list = this.state.data.filter((con) => {
          if (con.contactType === "A/c receivable responsible person")
            return con;
        });
        if (acReceivable_responsible_person_list.length < 2) {
          msg = "A/c receivable responsible person contact";
        }
      }
    } else {
      if (contact_row.contactType === "A/c Payable responsible person") {
        acPayable_responsible_person_list = this.state.data.filter((con) => {
          if (con.contactType === "A/c Payable responsible person") return con;
        });
        if (acPayable_responsible_person_list.length < 2) {
          msg = "A/c Payable responsible person contact";
        }
      }
    }
    return msg;
  }
  async onDelete(id, e) {
    if (this.state.isDisabled) return false;
    let msg = this.validateContact_details(id);

    if (msg) {
      utility.showAlert(
        "You need to fill at least one " + msg + " detail before delete."
      );
      Loader.hideLoader();
      return false;
    }
    var that = this;
    var config = {
      message: messages.confirmDeleteContact,
      onYesClick: async function () {
        Loader.showLoader();
        let { response, err } = await contactService.deleteContact(id);
        Loader.hideLoader();
        let msg = "";
        if (err) {
        } else if (response.data && response.data.err) {
        } else {
          if (response.data.success) {
            msg = response.data.msg;
          } else {
            msg = "Error while deleting!";
          }
          that.setState({
            deleteMsg: msg,
            msg: "",
            error: "",
          });
          that.getAllContactList();
        }
      },
      onNoClick: null,
    };
    utility.showConfirm(config);
  }

  randomFixedInteger(length) {
    if (length > 0) {
      return Math.floor(
        Math.pow(10, length - 1) +
        Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)
      );
    }
    return 0;
  }

  buttonClick() {
    this.setState({
      user: {
        contactPerson: "",
        title: "",
        contactType: "",
        salutation: "",
        lookupCode: "",
        designation: "",
        gender: "",
        emailId: "",
        telephoneNo: "",
        mobileNo: "",
        faxNumber: "",
        comment: "",
      },
      validationErrors: "",
      editflag: false,
      error: "",
      msg: "",
      deleteMsg: "",
      showModel: !this.state.showModel,
    });
  }

  onChange(e) {
    let name = e.target.name === "name" ? "contactPerson" : e.target.name;
    let value = e.target.value;

    if (
      name === "contactPerson" ||
      name === "title" ||
      name === "designation" ||
      name === "comment"
    ) {
      if (value.match(config.regex) || value === "") {
        this.setState({
          user: {
            ...this.state.user,
            [name]: value.toUpperCase(),
          },
        });
      }
    } else {
      this.setState({
        user: {
          ...this.state.user,
          [name]: value,
        },
      });
    }

    let validationErrors = Object.assign({}, this.state.validationErrors);
    if (name === "contactPerson") {
      if (value) {
        if (!ValidationReg.nameValid.test(value)) {
          validationErrors.contactPersonError = "Please provide a valid Name";
        } else {
          validationErrors.contactPersonError = "";
        }
      } else if (!value) {
        validationErrors.contactPersonError = "Please enter a Name";
      } else {
        validationErrors.contactPersonError = "";
      }
    }
    if (name === "title") {
      if (value) {
        if (!ValidationReg.nameValid.test(value)) {
          validationErrors.titleError = "Please provide a valid Title";
        } else {
          validationErrors.titleError = "";
        }
      } else if (!value) {
        validationErrors.titleError = "Please enter a Title";
      } else {
        validationErrors.titleError = "";
      }
    }
    if (name === "salutation") {
      if (value) {
        if (!ValidationReg.nameValid.test(value)) {
          validationErrors.salutationError =
            "Please provide a valid Salutation";
        } else {
          validationErrors.salutationError = "";
        }
      } else if (!value) {
        validationErrors.salutationError = "Please enter a Salutation";
      } else {
        validationErrors.salutationError = "";
      }
    }
    if (name === "designation") {
      if (value) {
        if (!ValidationReg.nameValid.test(value)) {
          validationErrors.designationError =
            "Please provide a valid Contact Designation";
        } else {
          validationErrors.designationError = "";
        }
      } else if (!value) {
        validationErrors.designationError =
          "Please enter a Contact Designation";
      } else {
        validationErrors.designationError = "";
      }
    }
    if (name === "lookupCode") {
      if (value) {
        if (!ValidationReg.alphanumericValid.test(value)) {
          validationErrors.lookupCodeError =
            "Please provide a valid Lookup Code";
        } else {
          validationErrors.lookupCodeError = "";
        }
      } else if (!value) {
        validationErrors.lookupCodeError = "Please enter a Lookup Code";
      } else {
        validationErrors.lookupCodeError = "";
      }
    }
    if (name === "telephoneNo") {
      if (value) {
        if (!ValidationReg.isMultipleTelNo.test(value)) {
          validationErrors.telephoneNoError =
            "Please provide a valid Telephone No.";
        } else {
          validationErrors.telephoneNoError = "";
        }
      } else if (!value) {
        validationErrors.telephoneNoError = "Please enter a Telephone No";
      } else {
        validationErrors.telephoneNoError = "";
      }
    }

    if (name === "telephoneExt") {
      if (value) {
        if (!ValidationReg.numbersonlyValid.test(value)) {
          validationErrors.telephoneExtError =
            "Please provide a valid Telephone Extension.";
        } else {
          validationErrors.telephoneExtError = "";
        }
      } else if (!value) {
        validationErrors.telephoneExtError =
          "Please enter a Telephone Extension";
      } else {
        validationErrors.telephoneExtError = "";
      }
    }
    if (name === "mobileNo") {
      if (value) {
        if (!ValidationReg.numbersonlyValid.test(value)) {
          validationErrors.mobileNoError =
            "Please provide a valid Mobile number";
        } else if (value.length !== 10) {
          validationErrors.mobileNoError =
            "Please provide a Mobile number of 10 digits";
        } else {
          validationErrors.mobileNoError = "";
        }
      } else if (!value) {
        validationErrors.mobileNoError = "Please enter a Mobile number";
      } else {
        validationErrors.mobileNoError = "";
      }
    }

    if (name === "faxNumber") {
      if (value) {
        if (!ValidationReg.faxValid.test(value)) {
          validationErrors.faxNumberError = "Please provide a valid Fax number";
        } else {
          validationErrors.faxNumberError = "";
        }
      }
    }
    if (name === "emailId") {
      if (value) {
        if (!ValidationReg.emailValid.test(value)) {
          validationErrors.emailIdError = "Please provide a valid Email";
        } else {
          validationErrors.emailIdError = "";
        }
      } else if (!value) {
        validationErrors.emailIdError = "Please enter an Email";
      } else {
        validationErrors.emailIdError = "";
      }
    }
    if (name === "gender") {
      if (!value) {
        validationErrors.genderError = "Please select a Gender";
      } else {
        validationErrors.genderError = "";
      }
    }
    if (name === "contactType") {
      if (!value) {
        validationErrors.contactTypeError = "Please select a Contact Type";
      } else {
        validationErrors.contactTypeError = "";
      }
    }

    this.setState({
      validationErrors: validationErrors,
    });
  }

  onKeyPress(e) {
    if (
      e.which === 32 ||
      (e.which !== 8 &&
        e.which !== 40 &&
        e.which !== 41 &&
        e.which !== 43 &&
        e.which !== 44 &&
        isNaN(String.fromCharCode(e.which)))
    )
      e.preventDefault();
  }

  async onSubmit(id) {
    Loader.showLoader();
    let msg, err;
    let validationFlag = false;
    let validationErrors = Object.assign({}, this.state.validationErrors);
    if (!this.state.user.contactPerson) {
      validationErrors.contactPersonError = "Please enter Name";
      validationFlag = true;
    } else if (validationErrors.contactPersonError) {
      validationErrors.contactPersonError = "Please enter valid Name";
      validationFlag = true;
    } else {
      validationErrors.contactPersonError = "";
    }
    if (!this.state.user.mobileNo) {
      validationErrors.mobileNoError = "Please enter Mobile No.";
      validationFlag = true;
    } else if (validationErrors.mobileNoError) {
      validationErrors.mobileNoError = "Please enter valid Mobile No.";
      validationFlag = true;
    } else {
      validationErrors.mobileNoError = "";
    }
    if (!this.state.user.emailId) {
      validationErrors.emailIdError = "Please enter Email";
      validationFlag = true;
    } else if (validationErrors.emailIdError) {
      validationErrors.emailIdError = "Please enter valid Email";
      validationFlag = true;
    } else {
      validationErrors.emailIdError = "";
    }
    if (!this.state.user.gender) {
      validationErrors.genderError = "Please select Gender";
      validationFlag = true;
    } else {
      validationErrors.genderError = "";
    }
    if (!this.state.user.contactType) {
      validationErrors.contactTypeError = "Please select Contact Type";
      validationFlag = true;
    } else {
      validationErrors.contactTypeError = "";
    }

    let userData = Object.assign({}, this.state.user);
    if (!id) {
      userData.contactId = uuidv4();
    } else {
      userData.contactId = id;
    }
    userData.clientId = this.state.clientId;

    if (validationFlag === false) {
      let response = await contactService.saveContact(userData);
      Loader.hideLoader();
      let newData = this.state.data.filter((x) => {
        return x.contactId !== id;
      });
      if (response) {
        if (response.response.data.success) {
          msg = response.response.data.msg;
          window.scrollTo(0, 0);
        } else {
          err = response.response.data.err;
          window.scrollTo(0, 0);
        }
      }
      this.setState({
        user: {
          contactPerson: "",
          title: "",
          contactType: "",
          salutation: "",
          lookupCode: "",
          designation: "",
          gender: "",
          emailId: "",
          telephoneNo: "",
          telephoneExt: "",
          mobileNo: "",
          faxNumber: "",
          comment: "",
        },
        error: err,
        msg: msg,
        deleteMsg: "",
        data: [...newData, userData],
        validationErrors: "",
        showModel: !this.state.showModel,
      });
    } else {
      Loader.hideLoader();
    }
    this.setState({
      validationErrors: validationErrors,
    });
  }

  async componentDidMount() {
    Loader.showLoader();

    let contactTypeData = await masterService.getMastersByGroup("ContactType");
    let contactTypeDataFilter =
      contactTypeData &&
      contactTypeData.response &&
      contactTypeData.response.data;
    if (this.props.clientType === "Customer") {
      contactTypeDataFilter = contactTypeDataFilter.filter(function (el) {
        return el.code !== "6";
      });
    } else {
      contactTypeDataFilter = contactTypeDataFilter.filter(function (el) {
        return el.code !== "4";
      });
    }

    Loader.hideLoader();
    this.getAllContactList();
    this.setState({
      contactTypeData: contactTypeDataFilter,
    });

    let clientId;
    if (Auth.get("userType") !== "InternalUser") {
      clientId = Auth.get("userId");
    } else {
      clientId = this.props.clientId;
    }
    Loader.showLoader();
    let { response, err } = await kyc.getKycStatus(clientId);
    Loader.hideLoader();
    if (err) {
    } else {
      this.kycStatus = response.data.kycStatus;
      if (Auth.get("userType") !== "InternalUser") {
        if (
          !this.kycStatus ||
          this.kycStatus === "REOPENED" ||
          this.kycStatus === "DRAFT" ||
          this.kycStatus === "REJECTED"
        ) {
          this.setState({
            isDisabled: false,
          });
        } else {
          this.setState({
            isDisabled: true,
          });
        }
      }
    }
    if (
      validateEntitlement(FUNCTIONALITY.generateXMLCSV, ENTITLEMENTS.create) &&
      this.kycStatus === "APPROVED"
    ) {
      this.getContactsForCSV();
    }
  }

  onClear() {
    this.setState({
      user: {
        contactPerson: "",
        title: "",
        contactType: "",
        salutation: "",
        lookupCode: "",
        designation: "",
        gender: "",
        emailId: "",
        telephoneNo: "",
        mobileNo: "",
        faxNumber: "",
        comment: "",
      },
      validationErrors: "",
      error: "",
      msg: "",
      deleteMsg: "",
    });
  }

  async generateContactXml() {
    Loader.showLoader();
    let data = {
      clientId: this.state.clientId,
      userType: this.state.userType,
    };
    let { response, err } = await xmlService.generateContactXml(data);
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      this.setState(
        {
          regenerateMsg: response.data.msg,
        },
        () => {
          setTimeout(() => this.setState({ regenerateMsg: "" }), 1000);
        }
      );
    }
  }

  async getContactsForCSV() {
    Loader.showLoader();
    let { response, err } = await contactService.getContactsForCSV(
      this.state.clientId
    );
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else if (response.data && response.data.length > 0) {
      let data = response.data;
      let headers = [];
      for (let i = 0; i < 1; i++) {
        for (let key in data[i]) {
          headers.push(key);
        }
      }
      this.setState({
        csvData: data,
        csvHeaders: headers,
      });
    }
  }

  getFileName() {
    let fileType = ".csv";
    let date = new Date(),
      dateformat = [
        date.getDate(),
        date.getMonth() + 1,
        date.getFullYear(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ].join("-");
    let fileName;
    fileName = "Contacts_" + this.state.clientId + "_" + dateformat + fileType;
    return fileName;
  }

  handlePrevNext(v, e) {
    if (v && v === "prev") {
      if (this.state.userType !== Auth.get("userType")) {
        this.props.navigate(
          "/kycs/" +
          this.state.clientId +
          "/" +
          this.state.userType +
          "/customer"
        );
      } else {
        this.props.navigate("/kyc/customer");
      }
    } else if (v && v === "next") {
      if (this.state.userType !== Auth.get("userType")) {
        this.props.navigate(
          "/kycs/" + this.state.clientId + "/" + this.state.userType + "/banks"
        );
      } else {
        this.props.navigate("/kyc/banks");
      }
    }
  }

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let disable = this.state.isDisabled;
    let formName = "",
      buttonName = "";
    if (this.state.editflag) {
      formName = "Edit Contact";
      buttonName = "Update";
    } else {
      formName = "New Contact";
      buttonName = "Save";
    }
    return (
      <div className="container-fluid inner-content" id="container">
        <div className="row mt-1">
          {this.state.userType === "Customer" ? (
            <div className="col-sm-12 text-center">
              <p className="text-danger text-center font-weight-bold">
                "A/c payable responsible person" and "Tax Responsible Person"
                contact details are mandatory <br />
                before submitting the KYC for approval.
              </p>
            </div>
          ) : (
            <div className="col-sm-12 text-center">
              <p className="text-danger text-center font-weight-bold">
                "A/c receivable responsible person" and "Tax responsible person"
                contact details are mandatory
                <br /> before submitting the KYC for approval.
              </p>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.state.deleteMsg && (
              <div className="alert alert-success"> {this.state.deleteMsg}</div>
            )}
            {this.state.msg && (
              <div className="alert alert-success">{this.state.msg}</div>
            )}
            {this.state.deleteErr && (
              <div className="alert alert-error">{this.state.deleteErr}</div>
            )}
            {this.state.error && (
              <div className="alert alert-error">{this.state.error}</div>
            )}

            {this.state.regenerateMsg && (
              <div className="alert alert-success">
                {this.state.regenerateMsg}
              </div>
            )}

            <span className="float-sm-right btn-group ">
              {validateEntitlement(
                FUNCTIONALITY.generateXMLCSV,
                ENTITLEMENTS.create
              ) &&
                this.kycStatus === "APPROVED" &&
                !this.state.showModel ? (
                <React.Fragment>
                  <button
                    className="btn  btn-warning btn-xs "
                    onClick={this.generateContactXml}
                  >
                    Generate XML
                  </button>
                  <XmlDownload
                    type="contact"
                    obj={{
                      clientId:
                        Auth.get("userType") !== "InternalUser"
                          ? Auth.get("userId")
                          : this.props.clientId,
                      userType:
                        Auth.get("userType") !== "InternalUser"
                          ? Auth.get("userType")
                          : this.props.clientType,
                    }}
                  />
                </React.Fragment>
              ) : null}
              {validateEntitlement(
                FUNCTIONALITY.generateXMLCSV,
                ENTITLEMENTS.create
              ) &&
                this.kycStatus === "APPROVED" &&
                !this.state.showModel ? (
                this.state.csvHeaders &&
                  this.state.csvHeaders.length > 0 &&
                  this.state.csvData &&
                  this.state.csvData.length > 0 ? (
                  <button className="btn  btn-info btn-xs">
                    <CSVLink
                      style={{ color: "black" }}
                      headers={this.state.csvHeaders}
                      data={this.state.csvData}
                      filename={this.getFileName()}
                    >
                      <i className="fa fa-download text-black"></i> CSV
                    </CSVLink>
                  </button>
                ) : null
              ) : null}
              {!this.state.showModel ? (
                <button
                  className="btn btn-info btn-xs "
                  title="Download PDF"
                  onClick={this.downloadPdfList.bind(this, this.state.clientId)}
                >
                  <i className=" fa fa-download text-black"></i> PDF
                </button>
              ) : null}
            </span>
            <button
              disabled={disable && !this.state.showModel}
              className={
                this.state.showModel
                  ? "btn btn-sm btn-danger fixedCtaBtn"
                  : "btn btn-sm btn-success  fixedCtaBtn"
              }
              onClick={this.buttonClick}
            >
              {this.state.showModel ? "CLOSE" : "ADD"}
            </button>
          </div>
          <div
            style={
              this.state.showModel ? { display: "none" } : { display: "block" }
            }
            className="col-sm-12 "
          >
            <DataTable
              keyField="id"
              pagination={{
                enabled: true,
                pageLength: 15,
                type: "long",
              }}
              title="Contacts"
              width="100%"
              headers={this.state.headers}
              data={this.state.data}
              noData="No records!"
            />

            <div className="row pt-0 mt-2">
              {this.state.userType === "Customer" ? (
                <div className="col-sm-12 text-center">
                  <p className="text-danger text-center font-weight-bold">
                    "A/c payable responsible person" and "Tax Responsible
                    Person" contact details are mandatory <br />
                    before submitting the KYC for approval.
                  </p>
                </div>
              ) : (
                <div className="col-sm-12 text-center">
                  <p className="text-danger text-center font-weight-bold">
                    "A/c receivable responsible person" and "Tax responsible
                    person" contact details are mandatory
                    <br /> before submitting the KYC for approval.
                  </p>
                </div>
              )}
            </div>

            <div className="row pt-2">
              <div className="col-sm-12 text-center">
                <a
                  className="fa fa-angle-double-left mr-3 text-muted arrow"
                  onClick={this.handlePrevNext.bind(this, "prev")}
                >
                  &nbsp;
                </a>
                <a
                  className="fa fa-angle-double-right text-black arrow"
                  onClick={this.handlePrevNext.bind(this, "next")}
                >
                  &nbsp;
                </a>
              </div>
            </div>
          </div>

          {this.state.showModel ? (
            <div className="col-sm-12">
              <form name="goToTop" id="formClient" autoComplete="off">
                <h3 style={{ textAlign: "center" }}>{formName}</h3>
                <div className="row">
                  <div className="col-sm-4">
                    <DropDown
                      label="Contact Type"
                      name="contactType"
                      required="true"
                      value={this.state.user.contactType || ""}
                      error={this.state.validationErrors.contactTypeError}
                      onChange={this.onChange}
                      defaultItem={defaultListItem}
                      list={this.state.contactTypeData}
                      valProp="name"
                      textProp="name"
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <DropDown
                      label="Gender"
                      name="gender"
                      required="true"
                      value={this.state.user.gender || ""}
                      error={this.state.validationErrors.genderError}
                      onChange={this.onChange}
                      defaultItem={defaultListItem}
                      list={genders}
                      valProp="name"
                      textProp="name"
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      autoComplete="nofill"
                      animatedClass="fg-animate"
                      type="text"
                      label="Title"
                      value={this.state.user.title || ""}
                      name="title"
                      error={this.state.validationErrors.titleError}
                      onChange={this.onChange}
                      disabled={disable}
                    />
                  </div>

                  <div className="col-sm-4">
                    <TextBox
                      autoComplete="nofill"
                      animatedClassName="fg-animate"
                      type="text"
                      label="Name"
                      value={this.state.user.contactPerson || ""}
                      name="name"
                      error={this.state.validationErrors.contactPersonError}
                      required="true"
                      onChange={this.onChange}
                      disabled={disable}
                    />
                  </div>

                  <div className="col-sm-4">
                    <TextBox
                      animatedClassName="fg-animate"
                      type="text"
                      label="Designation"
                      value={this.state.user.designation || ""}
                      name="designation"
                      error={this.state.validationErrors.designationError}
                      onChange={this.onChange}
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      animatedClassName="fg-animate"
                      type="text"
                      label="Email"
                      value={this.state.user.emailId || ""}
                      required="true"
                      name="emailId"
                      error={this.state.validationErrors.emailIdError}
                      onChange={this.onChange}
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      animatedClassName="fg-animate"
                      type="text"
                      label="Telephone No."
                      value={this.state.user.telephoneNo || ""}
                      name="telephoneNo"
                      error={this.state.validationErrors.telephoneNoError}
                      onChange={this.onChange}
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      animatedClassName="fg-animate"
                      type="text"
                      label="Telephone Extension"
                      value={this.state.user.telephoneExt || ""}
                      name="telephoneExt"
                      error={this.state.validationErrors.telephoneExtError}
                      onChange={this.onChange}
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      animatedClassName="fg-animate"
                      type="text"
                      label="Mobile No."
                      value={this.state.user.mobileNo || ""}
                      required="true"
                      name="mobileNo"
                      error={this.state.validationErrors.mobileNoError}
                      onChange={this.onChange}
                      maxLength="10"
                      autoComplete="off"
                      disabled={disable}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group ">
                      <label className="">Comment</label>
                      <textarea
                        className={
                          this.state.validationErrors.commentError
                            ? "is-invalid form-control"
                            : "form-control"
                        }
                        placeholder="Comment"
                        name="comment"
                        maxLength="255"
                        value={this.state.user.comment || ""}
                        onChange={this.onChange}
                        autoComplete="off"
                        disabled={disable}
                      />
                      <span className="error-msg">
                        {this.state.validationErrors.commentError}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-sm-12">
                    <button
                      className="btn btn-success rounded-0"
                      disabled={disable}
                      type="button"
                      onClick={this.onSubmit.bind(
                        this,
                        this.state.user.contactId
                      )}
                    >
                      {buttonName}
                    </button>
                    <span>&nbsp;</span>
                    <button
                      className="btn btn-default rounded-0"
                      type="button"
                      onClick={this.onClear}
                      disabled={disable}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </form>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

// HOC to inject outlet context props and navigation function
export default withOutletPropsAndNavigation(ContactList);